<template>
  <div>
    <vue-dropzone ref="myVueDropzone" :id="'file_upload' + question.answer.id"
      :options="dropzoneOptions" @vdropzone-removed-file="removeFile"
      @vdropzone-success="successfulUpload" :destroyDropzone="false"
      :categoryId="categoryId">
    </vue-dropzone>
  </div>
</template>

<script>
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import Cookie from 'js-cookie'
import axios from '../../auth.js'

export default {
  components: {
    vueDropzone: vue2Dropzone
  },
  props: {
    question: Object,
    categoryId: Number
  },
  methods: {
    removeFile: (file) => {
      axios.delete(file.deleteUrl)
    },
    successfulUpload: (file, response) => {
      file.deleteUrl = `${process.env.VUE_APP_ENDPOINT}/api/applicant/files/` + response.attachment_id;
    }
  },
  mounted() {
    this.question.answer.file_uploads.forEach((upload) => {
      let mockFile = {
        name: upload.file_name,
        accepted: true,
        size: upload.size,
        deleteUrl: `${process.env.VUE_APP_ENDPOINT}/api/applicant/files/${upload.id}/`
      };
      this.$refs.myVueDropzone.manuallyAddFile(mockFile, upload.url);
    });
  },
  data() {
    return {
      dropzoneOptions: {
        url: `${process.env.VUE_APP_ENDPOINT}/api/applicant/` + this.$route.params.org_name + '/' + this.$route.params.scholarship + '/answers/' + this.question.answer.id + '/files',
        withCredentials: true,
        headers: {
          'X-CSRF-Token': Cookie.get("XSRF-TOKEN")
        },
        addRemoveLinks: true,
        dictRemoveFileConfirmation: "Are you sure you want to remove this file?",
      }
    }
  }
}
</script>

<style>

</style>
